import React from 'react';
import { Route as ReactRouterRoute, useLocation, RouteProps } from 'react-router-dom';

export const Route: React.FC<RouteProps> = (props) => {
    const { pathname, search, hash } = useLocation();
    const key = [pathname, search, hash].join('|');
    return <ReactRouterRoute key={key} {...props} />;
};
